import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton";
import {AddRecordButton} from "../buttons/AddRecordButton";
import {FilterRecordButton} from "../buttons/FilterRecordButton";
import {rbacActions} from '../../../config/rbac/actions';
import config from '../config';


const useTools = () => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadRecordsButton key='reload'/>, <FilterRecordButton key='filter'/>];

    if (allowedActions.includes(rbacActions.DeleteUser)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreateUser)) {
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
